// Set from backend – certain partners have us hosted on reverse proxy, so all
// relative-path requests must be prefixed with the same path to proxy correctly
// Defaults to an empty string
export var PROXY_PATH = window.proxyPath || '';
export var getAppPath = function (staticPath) {
    return PROXY_PATH ? "".concat(PROXY_PATH).concat(staticPath) : staticPath;
};
